<template>
  <v-dialog
    v-model="active"
    width="500"
  >
    <v-card>
      <v-card-title class="headline">
        {{title}}
      </v-card-title>
      <v-card-text>
        {{content}}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="cancel"
        >
          {{cancelButtonText}}
        </v-btn>
        <v-btn
          text
          @click="confirm"
        >
          {{confirmButtonText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogModal",
  props: {
    active: Boolean,
    title: String,
    content: String,
    confirmButtonText: {
      type: String,
      default: "Ja"
    },
    cancelButtonText: {
      type: String,
      default: "Nei"
    }
  },
  methods: {
    confirm: function () {
      this.$emit("confirm")
    },
    cancel: function () {
      this.$emit("cancel")
    }
  }
}
</script>

<style>
</style>